import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DocumentsStudyFolderDTO } from '../dtos/documents-study-folder.dto';

@Injectable({
    providedIn: 'root',
})
export class DocumentCardService {
    constructor(private readonly httpClient: HttpClient) { }

    getDocumentCardRootFolder(
        organizationId: string,
        studyId: string,
    ): Observable<DocumentsStudyFolderDTO[]> {
        return this.httpClient.get<DocumentsStudyFolderDTO[]>(
            `${environment.dsmbHost}/dsmb/organization/${organizationId}/study/${studyId}/get-study-document-folder`,
        );
    }

    getDocumentCardSubFolder(
        organizationId: string,
        studyId: string,
        folderId: string,
    ): Observable<DocumentsStudyFolderDTO[]> {
        return this.httpClient.get<DocumentsStudyFolderDTO[]>(
            `${environment.dsmbHost}/dsmb/organization/${organizationId}/study/${studyId}/subfolder/${folderId}`,
        );
    }

    createDocumentCardFolder(
        newFolder: DocumentsStudyFolderDTO
    ): Observable<DocumentsStudyFolderDTO[]> {
        return this.httpClient.post<DocumentsStudyFolderDTO[]>(
            `${environment.dsmbHost}/dsmb/organization/${newFolder.organizationId}/study/${newFolder.studyId}/add-study-document-folder`,
            newFolder);
    }

    updateDocumentCardFolder(
        updatedFolder: DocumentsStudyFolderDTO
    ): Observable<DocumentsStudyFolderDTO[]> {
        return this.httpClient.post<DocumentsStudyFolderDTO[]>(
            `${environment.dsmbHost}/dsmb/organization/${updatedFolder.organizationId}/study/${updatedFolder.studyId}/update-study-document-folder`,
            updatedFolder);
    }

    deleteDocumentCardFolder(
        folderToDelete: DocumentsStudyFolderDTO
    ): Observable<DocumentsStudyFolderDTO[]> {
        return this.httpClient.post<DocumentsStudyFolderDTO[]>(
            `${environment.dsmbHost}/dsmb/organization/${folderToDelete.organizationId}/study/${folderToDelete.studyId}/delete-study-document-folder`,
            folderToDelete);
    }

    getDocumentCardDetails(
        organizationId: string,
        studyId: string,
        folderId: string,
    ): Observable<DocumentsStudyFolderDTO> {
        return this.httpClient.get<DocumentsStudyFolderDTO>(
            `${environment.dsmbHost}/dsmb/organization/${organizationId}/study/${studyId}/folder/${folderId}`,
        );
    }

    updateDocumentFolder(
        organizationId: string,
        studyId: string,
        documentId: string,
        versionNo: string,
        folderId: string
    ): Observable<void> {
        return this.httpClient.post<void>(
        `${environment.dsmbHost}/dsmb/organization/${organizationId}/study/${studyId}/document/${documentId}/version/${versionNo}/update-folder/${folderId}`,
        null
        );
    }

}
